export const isEmpty = (v) => v === null ||
    v === undefined ||
    v === '' ||
    (Array.isArray(v) && v.length === 0) ||
    (typeof v === 'object' && Object.keys(v).length === 0);
//# sourceMappingURL=isEmpty.js.map